module.exports = __webpack_public_path__ + "img/fatal-fury.a7466214.png";